// extracted by mini-css-extract-plugin
export default {"issueTypeTokenWrapper":"IssueTypeEvent-module__issueTypeTokenWrapper--_qtQ7"};